import React from 'react';
import Footer from '../Footer';
import berendezkedesIcon from '../../img/berendezkedes.png';
import biztonsagIcon from '../../img/biztonsag.png';
import elhelyezesIcon from '../../img/elhelyezes.png';
import intezmenyIcon from '../../img/intezmeny.png';
import tamogatasIcon from '../../img/tamogatas.png';
import telefonIcon from '../../img/telefon.png';
import tvIcon from '../../img/tv.png';
import wifiIcon from '../../img/wifi.png';
import './styles/SubInfoPage.css';

const SectionTitle = ({ icon, alt, children }) => (
  <h4 className="content-icon-heading">
    <img src={icon} alt={alt} className="content-heading-icon" />
    <span>{children}</span>
  </h4>
);

const ApartmentsPage = () => {
  return (
    <div className="sub-info-page">
      <section className="sub-info-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Apartmanjaink</h2>
            <p className="section-subtitle">
              Lakóegységek és felszereltség
            </p>
          </div>

          <div className="content-card">
            <h3>Elérhető apartmanok</h3>
            <div className="content-body">
              <p>Az intézményben <strong>123 akadálymentesített apartman</strong> áll rendelkezésre:</p>
              
              <div className="apartments-grid">
                <div className="apartment-item">
                  <strong>22 m²</strong>
                  <span>8 db</span>
                </div>
                <div className="apartment-item">
                  <strong>25 m²</strong>
                  <span>17 db</span>
                </div>
                <div className="apartment-item">
                  <strong>26-30 m²</strong>
                  <span>76 db</span>
                </div>
                <div className="apartment-item">
                  <strong>31-40 m²</strong>
                  <span>20 db</span>
                </div>
                <div className="apartment-item">
                  <strong>70 m²</strong>
                  <span>2 db</span>
                </div>
              </div>
              
              <SectionTitle icon={intezmenyIcon} alt="">Alapfelszereltség</SectionTitle>
              <p>Minden lakóegység saját fürdőszobával (tusoló+wc) rendelkezik és akadálymentesített.</p>
              
              <div className="features-grid">
                <div className="feature-item">
                  <img src={telefonIcon} alt="" className="feature-icon" />
                  <div>
                    <strong>Digitális telefon készülék</strong>
                    <p>Apartmanonként elérhető</p>
                  </div>
                </div>
                <div className="feature-item">
                  <img src={tvIcon} alt="" className="feature-icon" />
                  <div>
                    <strong>Digitális TV antenna</strong>
                    <p>Apartmanonként elérhető</p>
                  </div>
                </div>
                <div className="feature-item">
                  <img src={wifiIcon} alt="" className="feature-icon" />
                  <div>
                    <strong>WiFi internet</strong>
                    <p>Az intézmény területén biztosított, alapvető böngészésre alkalmas internetkapcsolat.</p>
                  </div>
                </div>
              </div>
              
              <SectionTitle icon={berendezkedesIcon} alt="">Berendezés</SectionTitle>
              <ul>
                <li><strong>Általános gondozási szinteken:</strong> Az apartmanok bútorozatlanok, saját bútorzattal berendezhetők</li>
                <li><strong>Fokozott gondozást biztosító részlegeken:</strong> A lakrészek funkcionálisan berendezettek</li>
              </ul>
              
              <SectionTitle icon={elhelyezesIcon} alt="">Férőhelyek</SectionTitle>
              <ul>
                <li><strong>Általános gondozási szinteken:</strong> A lakrészek 1 vagy 2 személy elhelyezésére alkalmasak</li>
                <li><strong>Fokozott gondozást biztosító részlegen:</strong> 2 személyes elhelyezésre van lehetőség</li>
              </ul>
              
              <div className="important-note">
                <SectionTitle icon={biztonsagIcon} alt="">Fontos tudnivalók</SectionTitle>
                <p>A belépési díjjal megszerzett használat joga nem ruházható át, nem örökölhető és nem örökíthető.</p>
              </div>
              
              <div className="contact-section">
                <SectionTitle icon={tamogatasIcon} alt="">További információ</SectionTitle>
                <p>Az árakról és az elhelyezési lehetőségekről a Dokumentumok/Adatlapok menüben, a várakozási időről és az aktuálisan elérhető szabad férőhely(ek)ről telefonon, e-mailen, vagy előre egyeztetett időpontban személyes találkozáskor informálódhat.</p>
                <div className="contact-email">
                  <strong>📧 napviragotthon@napviragotthon.hu</strong>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      <Footer />
    </div>
  );
};

export default ApartmentsPage;
